import { Injectable } from '@angular/core';

import { AppConfigurationService } from 'shared/app-configuration';

import { ReportPeriodApiPaths } from './report-period.paths.api';

@Injectable()
export class ReportPeriodConfiguration {
    apiPaths: ReportPeriodApiPaths;

    constructor(private readonly appConfiguration: AppConfigurationService) {
        this.apiPaths = new ReportPeriodApiPaths(
            this.appConfiguration.configuration.uris.reportPeriodService,
        );
    }
}
